import { ExtractionError } from "./ExtractionError";

export enum TranslationStatus {
  EXTRACTION_RUNNING = "Extraction running", // Extraction from ERP is in progress
  EXTRACTED = "Ready To Translate", // Successfully extracted from ERP, ready for translation
  EXTRACTION_FAILED = "Extraction failed", // Extract from ERP failed

  // Translation stages
  IN_TRANSLATION = "Translation ongoing", // Translator is working on it

  // Review stages
  IN_REVIEW = "Translation to review", // Controller is reviewing the translation, We can aswell call it : TRANSLATED
  REVIEW_COMPLETED = "Translation reviewed", // Review completed and approved, ready for Integration.
  REVIEW_REJECTED = "Translation review failed", // Review rejected, sent back to translator

  INTEGRATION_RUNNING = "Integration running", // Integration to ERP is in progress
  INTEGRATED = "Integrated", // Successfully integrated back to ERP
  INTEGRATION_FAILED = "Integration failed",
}
export const getTranslationStatusOptions = () => {
  return Object.values(TranslationStatus).map((status) => ({
    value: status,
    label: status,
  }));
};
// export d'une traduction
export interface Translation {
  id: number;
  code: string;
  product: string;
  destinationLanguage: string;
  version: string;
  mavenVersion: string;
  status: TranslationStatus;
  error: ExtractionError;
  createdAt?: string;
  dueDate?: string;
  referenceTranslationId?: string;
  initialLabelsToTranslate: number;
  nbLabelsToTranslate: number;
}
